/* eslint no-use-before-define: 0 */

import $ from "jquery";

import { ServiceIconComponent, serviceIconClickedEventSource, serviceIconClicked$ } from "./service-icon.component";

/*
 * Finds and initializes all child service-icons components.
 * Fires reset of all service-icons components when screen resolution is changed.
 */

export default class ServiceListComponent {
    constructor(jqDomObject, GUID) {
        this.serviceIcons = [];
        this.GUID = GUID;
        this.currentChildIndex = -1;
        this.jqDomObject = jqDomObject;
        this.initialize();
    }

    /**
     * @private
     */
    initialize() {
        const classScope = this;

        initializeServiceIcons();
        subscribeOnEvents();

        function subscribeOnEvents() {
            serviceIconClicked$.subscribe((index) => {
                classScope.currentChildIndex = index;
            });

            /*
                 * We should reset active text block when screen size changes.
                 * Because of different amount of text block for desktop, mobile and tablet versions.
             */
            $(window).resize(() => {
                serviceIconClickedEventSource.next(classScope.currentChildIndex);
            });
        }

        function initializeServiceIcons() {
            classScope.jqDomObject.find(".service-list-item").each(function (index) {
                const serviceIcon = new ServiceIconComponent($(this), classScope.GUID, index, classScope.jqDomObject);
                classScope.serviceIcons.push(serviceIcon);
            });
        }
    }
}
